module.exports = __webpack_public_path__ + "img/company_icon.7033bf3b.svg";